module.exports = __webpack_public_path__ + "img/hn.48410614.svg";